import { SenderIdAuthorisationItem } from "../../../interfaces/sender-id-authorisation-item.interface";

export const authorisedOpasFilterPredicate = (data: SenderIdAuthorisationItem, filter: string): boolean => {
  const transformedFilter = filter.trim().toLowerCase();

  return (
    data.organisationName.toLowerCase().includes(transformedFilter) ||
    data.status.toLowerCase().includes(transformedFilter)
  );
};
